var map = {
	"./activeforms.png": "a728",
	"./completedvisits.png": "65ae",
	"./formscount.png": "b633",
	"./openquery.png": "6bbd",
	"./overduevisits.png": "089d",
	"./queryactivitytable.png": "813b",
	"./siteschart.png": "fa4d",
	"./subjectchart.png": "c9ee",
	"./totalquery.png": "361b",
	"./totalsites.png": "7d26",
	"./totalsubjects.png": "5fbc",
	"./totalusers.png": "3002",
	"./upcommingvisits.png": "6321"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86c2";